import { render } from "./ListeTransfertPage.vue?vue&type=template&id=19a3b7de&ts=true"
import script from "./ListeTransfertPage.vue?vue&type=script&lang=ts"
export * from "./ListeTransfertPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__